import React, { useMemo } from "react";
import "./BingoWin.css";

const COLORS = [
  "#f0f7da", "#6b8c3e", "#3d2b1f", "#a3c466",
  "#d4e89a", "#527030", "#e8f4b8", "#8faa56",
];

function Confetti() {
  const pieces = useMemo(
    () =>
      Array.from({ length: 60 }, (_, i) => ({
        id: i,
        left: `${Math.random() * 100}%`,
        color: COLORS[i % COLORS.length],
        delay: `${Math.random() * 2}s`,
        duration: `${2.5 + Math.random() * 2}s`,
        spin: `${Math.random() > 0.5 ? "" : "-"}${360 + Math.floor(Math.random() * 360)}deg`,
        size: `${8 + Math.floor(Math.random() * 8)}px`,
        shape: Math.random() > 0.4 ? "2px" : "50%",
      })),
    []
  );

  return (
    <div className="confetti">
      {pieces.map((p) => (
        <div
          key={p.id}
          className="confetti__piece"
          style={{
            left: p.left,
            backgroundColor: p.color,
            width: p.size,
            height: p.size,
            borderRadius: p.shape,
            "--delay": p.delay,
            "--duration": p.duration,
            "--spin": p.spin,
          }}
        />
      ))}
    </div>
  );
}

export default function BingoWin({ onDismiss }) {
  return (
    <>
      <Confetti />
      <div className="bingo-win-overlay" onClick={onDismiss}>
        <div className="bingo-win-box" onClick={(e) => e.stopPropagation()}>
          <div className="bingo-win-text">BINGO!</div>
          <div className="bingo-win-sub">🎉 Gratulacje! 🎉</div>
          <p className="bingo-win-hint">Dotknij gdziekolwiek, aby zamknąć</p>
        </div>
      </div>
    </>
  );
}
